import pageComissionerRouter from '../../components/page-comissioner/index'

export default [
    {
        path: '/management',
        name: 'Comissioner',
        component: () => import('../../views/comissioner'),
        children: [
            ...pageComissionerRouter
        ]
    }
]